module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/promise.js
// module id = 138
// module chunks = 0